module.exports = __webpack_public_path__ + "img/attached.126f9f13.svg";